module.exports = __webpack_public_path__ + "img/face-smile-upside-down.7ab7d4f0.svg";